import React, {ReactNode} from 'react';
import {Button} from './Button';

const Card = ({ title, action, secondaryAction, children }: { title: string; action?: { label: string; onClick: any }, secondaryAction?: { label: string; onClick: any }, children: ReactNode }) => {
  return (
    <div className="overflow-hidden rounded-lg bg-white shadow">
      <div className="border-b border-gray-200 bg-white px-4 py-4 sm:px-6">
        <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="ml-4 ">
            <h3 className="text-base font-semibold text-gray-900">{ title }</h3>
          </div>
          { (action || secondaryAction) && (
            <div className="ml-4 shrink-0 space-x-2">
              { action && (
                <Button
                  type="button"
                  size='sm'
                  color='red'
                  onClick={action.onClick}
                >
                  { action.label }
                </Button>
              )}
              { secondaryAction && (
                <Button
                  type="button"
                  size='sm'
                  onClick={secondaryAction.onClick}
                >
                  { secondaryAction.label }
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="px-4 py-5 sm:p-6">{ children }</div>
    </div>
  );
};

export default Card;